import React from 'react'

const SuggestCampaignPage = () => {
  return (
    <div className="flex justify-center items-center min-h-screen">
      <div className="text-3xl">Coming Soon</div>
    </div>)
}

export default SuggestCampaignPage